import React, { useCallback, useState, useMemo } from "react";
import { Typography } from "@mui/material";
import { useItemsListStyles } from "./css";
import { ArrowForwardIosOutlined } from "@mui/icons-material";
import { TextField } from "./index";
import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@mui/icons-material";
import { Logo } from "../logo";
import { logOut } from "../modules/auth/slices/authSlice";
import { useAppDispatch } from "../app/hook";

interface IItemsList {
  title: string;
  data?: { label: string; value: number | string }[];
  actionBtnTitle?: string;
  actionBtnClick?: () => void;
  onItemClick: (value: any) => void;
  logoSrc?: string;
}

function ItemsList(props: IItemsList) {
  const { classes, cx } = useItemsListStyles();
  const { title, data, actionBtnTitle, actionBtnClick, onItemClick, logoSrc } =
    props;
  const [translate] = useTranslation();
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState("");
  const showButton = useMemo(() => data && data.length > 3, [data]);
  const [showAll, setShowAll] = useState(false);

  const handleFilter = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  }, []);

  const handleShowAll = useCallback(() => setShowAll(true), []);
  const handleShowLess = useCallback(() => setShowAll(false), []);

  const logUserOut = React.useCallback(() => {
    dispatch(logOut());
  }, [dispatch]);

  const filteredItems = useMemo(
    () =>
      data
        ? data.filter((item) => {
            const label = item.label ? item.label.toLowerCase() : "";
            const value = item.value ? ("" + item.value).toLowerCase() : "";
            const searching = filter ? filter.toLowerCase() : "";
            return label.includes(searching) || value.includes(searching);
          })
        : [],
    [data, filter]
  );

  return (
    <div className={classes.container}>
      <div className={classes.listContainer}>
        {logoSrc && !showAll && (
          <div className={classes.logo}>
            <Logo src={logoSrc} width="170" />
          </div>
        )}

        <Typography className={classes.title}>{title}</Typography>

        {!showAll && (
          <div className={classes.search}>
            <TextField
              onChange={handleFilter}
              startAdornment={<SearchOutlined fontSize="small" />}
              name="filter"
              placeholder={translate("toLookFor")}
              fullWidth
              fillColor="grey"
            />
          </div>
        )}

        {filteredItems && (
          <div className={classes.list}>
            {filteredItems.map((db, index) => {
              if (!showAll && index > 2) return;

              return (
                <div
                  className={cx("list-rows", classes.listElements)}
                  key={index}
                  onClick={() => onItemClick(db.value)}
                >
                  {db.label || db.value}
                  <ArrowForwardIosOutlined sx={{ fontSize: 16 }} />
                </div>
              );
            })}
          </div>
        )}

        {showButton && !showAll && filter.length === 0 && (
          <div className={classes.showButton} onClick={handleShowAll}>
            <Typography variant="body2">{translate("showAll")}</Typography>
          </div>
        )}

        {showAll && filter.length === 0 && (
          <div className={classes.showButton} onClick={handleShowLess}>
            <Typography variant="body2">{translate("showLess")}</Typography>
          </div>
        )}
      </div>

      <div className={classes.actionButton}>
        <div onClick={logUserOut}>
          <Typography variant="body2">
            {translate("logout", "Atsijungti")}
          </Typography>
        </div>

        <div onClick={actionBtnClick}>
          <Typography variant="body2">{actionBtnTitle}</Typography>
        </div>
      </div>
    </div>
  );
}

export default ItemsList;
